import { type MouseEventHandler, type PropsWithChildren } from 'react'

type TAudioCardZoneProps = PropsWithChildren<{
    className: string
    onClick?: MouseEventHandler<HTMLDivElement>
}>

export const AudioCardZone = ({ className, onClick, children }: TAudioCardZoneProps) =>
    onClick ? (
        <div className={className} role="presentation" onClick={onClick}>
            {children}
        </div>
    ) : (
        <div className={className}>{children}</div>
    )
